// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"105":"c5d240dc","130":"8e15b7fb","838":"0c2b170d"}[chunkId] + ".css";
};